import { EUserActionTypes } from '../../actions/user';
import { TReduxActions } from '../../types/redux';
import { TUser } from '../../types/user/user';

const defaultState: TUser = null;

export function userReducer(state: TUser = defaultState, action: TReduxActions): TUser {
  switch (action.type) {
    case EUserActionTypes.SetUser: {
      return action.payload;
    }

    default:
      return state;
  }
}
